<template>
  <v-row class="pt-9 mb-10">
    <v-col cols="12" sm="6">
      <h3 class="gray--text mb-8 mb-md-0">{{ title }}</h3>
    </v-col>
    <v-col cols="6" sm="3" class="offset-sm-3" v-if="buttonNewItem">
      <BaseButton
        class="secondary text-uppercase subtitle-2 font-weight-bold mb-10 mb-sm-0"
        width="100%"
        @click="$emit('next-step', null, typeItem)"
      >
        <v-icon class="pr-3 add-icon">fa-plus</v-icon>
        {{ nameButton }}
      </BaseButton>
    </v-col>
    <v-col cols="12" class="mt-4">
      <BaseDataTable
        :headers="tableHeaders"
        :items="items"
        hide-default-footer
        @click:row="editItem"
        class="eg-table"
      >
        <template v-slot:[`item.modalidade.nome`]="{ item }">
          <div :class="borderColor(item)">
            {{ item.modalidade.nome }}
          </div>
        </template>
        <template v-slot:[`item.submodalidade.nome`]="{ item }">
          <div :class="borderColor(item)">
            {{ item.submodalidade.nome }}
          </div>
        </template>
        <template v-slot:[`item.liberacao`]="{ item }">
          {{ typeRelease(item) }}
        </template>
        <template v-slot:[`item.valor_limite_credito`]="{ item }">
          {{
            item.valor_limite_credito &&
              asMoneyString(item.valor_limite_credito)
          }}
        </template>
        <template v-slot:[`item.ativo`]="{ item }">
          {{ nameStatus(item) }}
        </template>
      </BaseDataTable>
      <BaseErrorMessages
        v-if="errorMessages.length > 0"
        :error-messages="errorMessages"
      />
    </v-col>
  </v-row>
</template>

<script>
import { requiredInput } from "@/utils/rules.js";
import { asMoneyString } from "@/utils/formats.js";
import { mapState } from "vuex";

const defaultTableHeadersModality = [
  { text: "Nome", value: "modalidade.nome", sortable: false },
  { text: "Liberação", value: "liberacao", sortable: false },
  { text: "Situação", value: "ativo", sortable: false }
];

const tableHeadersModalityGarantia = [
  { text: "Nome", value: "modalidade.nome", sortable: false },
  { text: "Limite de Crédito", value: "valor_limite_credito", sortable: false },
  { text: "Liberação", value: "liberacao", sortable: false },
  { text: "Situação", value: "ativo", sortable: false }
];

const defaultTableHeadersSubModality = [
  { text: "Nome", value: "submodalidade.nome", sortable: false },
  { text: "Liberação", value: "liberacao", sortable: false },
  { text: "Situação", value: "ativo", sortable: false }
];

const tableHeadersSubModalityGarantia = [
  { text: "Nome", value: "submodalidade.nome", sortable: false },
  { text: "Limite de Crédito", value: "valor_limite_credito", sortable: false },
  { text: "Liberação", value: "liberacao", sortable: false },
  { text: "Situação", value: "ativo", sortable: false }
];

export default {
  name: "ModalitySelection",
  props: {
    items: {
      type: Array
    },
    errorMessages: {
      type: Array
    },
    title: {
      type: String
    },
    buttonNewItem: {
      type: Boolean,
      default: true
    },
    typeItem: {
      type: String
    }
  },
  data: () => ({
    requiredInput,
    tableHeaders: null,
    asMoneyString,
    nameButton: null,
    tableHeadersModalityGarantia,
    defaultTableHeadersModality,
    defaultTableHeadersSubModality,
    tableHeadersSubModalityGarantia
  }),
  created() {
    this.updateItems();
  },
  methods: {
    updateItems() {
      this.tableHeaders =
        this.typeItem == "modality"
          ? this.tableHeadersModality
          : this.tableHeadersSubModality;
      this.nameButton =
        this.typeItem == "modality"
          ? "INCLUIR MODALIDADE"
          : "INCLUIR SUBMODALIDADE";
    },
    removeItemList(item) {
      const index = this.items.indexOf(item);
      this.items.splice(index, 1);
    },
    typeRelease(item) {
      return item.tomador ? "TOMADOR MATRIZ/FILIAL" : "GRUPO";
    },
    nameStatus(item) {
      return item.ativo ? "ATIVO" : "INATIVO";
    },
    borderColor(item) {
      const status = item.ativo ? "lightGreen" : "pink";
      return `eg-table__border eg-table__border-${status}`;
    },
    editItem(item) {
      this.$emit("next-step", item, this.typeItem);
    }
  },
  computed : {
    ...mapState("me", ["userAreaIsGarantia"]),
    tableHeadersModality() {
      return this.userAreaIsGarantia ? this.tableHeadersModalityGarantia : this.defaultTableHeadersModality;
    },
    tableHeadersSubModality() {
      return this.userAreaIsGarantia ? this.tableHeadersSubModalityGarantia : this.defaultTableHeadersSubModality;
    }
  }
};
</script>
<style lang="sass">
.eg-table
  .v-data-table__wrapper
    @media (min-width:960px)
      overflow: visible !important
  td
    position: relative

  &__border::before
    overflow: visible !important
    display: block
    position: absolute
    background-color: #CCC
    width: 5px
    border-radius: 2px
    top: 8px
    bottom: 8px
    left: 0px
    margin-left: -3px
    content: " "
  &__border-lightGreen::before
    background-color: var(--v-lightGreen-base) !important
  &__border-pink::before
    background-color: var(--v-pink-base) !important
</style>
